import 'controllers/frontend';
import { Application } from "stimulus"
import StaticSearchController from "../controllers/home/static_search_controller"

const application = Application.start()
application.register("static-search", StaticSearchController)
// import 'alpinejs';

require('@rails/ujs').start();
require('turbolinks').start();
require('@rails/activestorage').start();
require('channels');
// eslint-disable-next-line import/extensions
require('custom/glidejs_custom.js');

const images = require.context('../images', true, /\.(bmp|gif|jpe?g|png|tiff|ico|avif|webp|svg)$/i);
/* eslint-disable no-unused-vars */
const imagePath = (name) => images(name, true);

window.initPlaces = function (...args) {
  const event = document.createEvent('Events');
  event.initEvent('google-maps-callback', true, true);
  event.args = args;
  window.dispatchEvent(event);
};
